import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from 'react';
var useIsClient = function useIsClient() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isClient = _useState2[0],
    setClient = _useState2[1];
  var key = isClient ? 'client' : 'server';
  useEffect(function () {
    setClient(true);
  }, []);
  return {
    isClient: isClient,
    key: key
  };
};
export default useIsClient;